import { defineStore } from 'pinia';

// Starts true so the loader is already up for the very first render, before
// the router's first beforeEach guard has had a chance to run.
export const useRouteLoadingStore = defineStore('routeLoading', {
  state: () => ({
    isLoading: true,
  }),

  actions: {
    start() {
      this.isLoading = true;
    },

    stop() {
      this.isLoading = false;
    },
  },
});
